export default __webpack_public_path__ + "static/media/ico-link-blank.81311efd.svg";